type Campaigns = 'origin_source' | 'origin_medium';
type OptionalCampaigns = Partial<Record<Campaigns, string>>;

export const getOriginCampaign = (): OptionalCampaigns => {
  const params = new URLSearchParams(window.location.search);
  const url_gclid = params.get('gclid');
  let campaigns: OptionalCampaigns = {};

  if (document.referrer) {
    const referrer = new URL(document.referrer);
    if (referrer.hostname.includes('google') && url_gclid) {
      campaigns = {
        origin_source: 'google',
        origin_medium: 'cpc'
      };
    } else if (referrer.hostname.includes('google') && !url_gclid) {
      campaigns = {
        origin_source: 'google',
        origin_medium: 'organic'
      };
    } else {
      campaigns = {
        origin_source: referrer.hostname,
        origin_medium: referrer.pathname
      };
    }
  } else {
    campaigns = {
      origin_source: 'unknown',
      origin_medium: 'unknown'
    };
  }
  return campaigns;
};
